var map = {
	"./Black_Account_Icons-01.png": 675,
	"./Black_Account_Icons-02.png": 676,
	"./Black_Account_Icons-03.png": 677,
	"./Black_Account_Icons-04.png": 678,
	"./Black_Account_Icons-05.png": 679,
	"./Black_Account_Icons-06.png": 680,
	"./Black_Account_Icons-07.png": 681,
	"./Black_Account_Icons-08.png": 682,
	"./Black_Account_Icons-09.png": 683,
	"./Black_Account_Icons-10.png": 684,
	"./Black_Account_Icons-11.png": 685,
	"./Black_Account_Icons-12.png": 686,
	"./Black_Account_Icons-13.png": 687,
	"./Black_Account_Icons-14.png": 688,
	"./FilePresentOutlined.svg": 689,
	"./accuracyAccountsDemo_downloadMT4.jpg": 690,
	"./accuracyAccountsReal_downloadMT4.jpg": 691,
	"./alert@2x.svg": 692,
	"./apple-brands.svg": 693,
	"./arrow_up_from_box.svg": 694,
	"./bankWire.svg": 695,
	"./bdswissDemo_downloadMT4.png": 696,
	"./bdswissGlobalDemo_downloadMT4.png": 697,
	"./bdswissGlobalReal02_downloadMT4.png": 698,
	"./bdswissGlobalReal03_downloadMT4.png": 699,
	"./bdswissGlobalReal04_downloadMT4.png": 700,
	"./bdswissGlobalReal05_downloadMT4.png": 701,
	"./bdswissGlobalReal_downloadMT4.png": 702,
	"./bdswissGlobalReal_downloadMT5.png": 703,
	"./bdswissReal02_downloadMT4.png": 704,
	"./bdswissReal03_downloadMT4.png": 705,
	"./bdswissReal04_downloadMT4.png": 706,
	"./bdswissReal05_downloadMT4.png": 707,
	"./bdswissReal_downloadMT4.png": 708,
	"./bdswissReal_downloadMT5.png": 709,
	"./bdswissSCDemo_downloadMT4.png": 710,
	"./bdswissSCReal01_downloadMT4.png": 711,
	"./bdswissSCReal02_downloadMT4.png": 712,
	"./bdswissSCReal03_downloadMT4.png": 713,
	"./bdswissSCReal04_downloadMT4.png": 714,
	"./bdswissSCReal05_downloadMT4.png": 715,
	"./bdswiss_grey.png": 716,
	"./bdswiss_white.png": 717,
	"./bg-image-affiliate.png": 718,
	"./bitwallet-bdSwiss-dark.svg": 719,
	"./bitwallet-bdSwiss-light.svg": 720,
	"./bitwallet-swissMarkets-dark.svg": 721,
	"./bitwallet-swissMarkets-light.svg": 722,
	"./card.svg": 723,
	"./check_circle.png": 724,
	"./chf.png": 725,
	"./competitions.png": 726,
	"./complimentary@2x.svg": 727,
	"./control-radio-off.png": 728,
	"./control-radio-on.png": 729,
	"./crypto.svg": 730,
	"./cvv.svg": 731,
	"./deposit-card.svg": 732,
	"./diners.png": 733,
	"./dkk.png": 734,
	"./document-upload-failure-dark.png": 735,
	"./document-upload-failure-light.png": 736,
	"./document-upload-success-black.png": 737,
	"./document-upload-success-dark.png": 738,
	"./document-upload-success-light.png": 739,
	"./documents-empty-dark.png": 740,
	"./documents-empty-light.png": 741,
	"./downloadPdf-light.png": 742,
	"./downloadPdf.png": 743,
	"./dpWorldTourChampionship-dark.svg": 744,
	"./dpWorldTourChampionship-light.svg": 745,
	"./eWallet.svg": 746,
	"./eur.png": 747,
	"./exp-date.svg": 748,
	"./fees@2x.svg": 749,
	"./filterIcon.png": 750,
	"./gbp.png": 751,
	"./icon-add-account.svg": 446,
	"./icon-appstore@2x.png": 752,
	"./icon-arrow-right-dark.png": 753,
	"./icon-arrow-right-light.png": 754,
	"./icon-bank-wire.svg": 755,
	"./icon-checkbox.svg": 756,
	"./icon-close-dark.svg": 757,
	"./icon-close-light.svg": 758,
	"./icon-close.png": 759,
	"./icon-contact-callback@2x.png": 760,
	"./icon-contact-callback@2x.svg": 761,
	"./icon-contact-chat@2x.png": 447,
	"./icon-contact-chat@2x.svg": 448,
	"./icon-contact-email@2x.png": 762,
	"./icon-contact-email@2x.svg": 763,
	"./icon-contact-faqs@2x.png": 764,
	"./icon-contact-faqs@2x.svg": 765,
	"./icon-contact-oneOnOneSession@2x.png": 766,
	"./icon-contact-telegram@2x.png": 767,
	"./icon-contact-whatsapp@2x.png": 768,
	"./icon-crypto.svg": 769,
	"./icon-document.svg": 770,
	"./icon-facebook@2x.png": 771,
	"./icon-google-play@2x.png": 772,
	"./icon-notification.svg": 773,
	"./icon-profile-big.svg": 774,
	"./icon-profile.svg": 775,
	"./icon-spoa.svg": 776,
	"./icon-swapFree.svg": 777,
	"./icon-telegram@2x.png": 778,
	"./icon-twitter@2x.png": 779,
	"./icon_accounts_dashboard.svg": 780,
	"./icon_logout_dashboard.svg": 781,
	"./icon_notification_dashboard.svg": 782,
	"./icon_profilesettings_dashboard.svg": 783,
	"./icon_support_dashboard.svg": 784,
	"./icon_transaction_dashboard.svg": 785,
	"./jcb.png": 786,
	"./knet-logo.png": 449,
	"./languages.png": 787,
	"./limit-failure-dark.png": 788,
	"./limit-failure-light.png": 789,
	"./logo-accuracy.png": 790,
	"./logo-bdstrading-white.svg": 791,
	"./logo-bdstrading.svg": 792,
	"./logo-bdswiss-white.svg": 793,
	"./logo-bdswiss.png": 794,
	"./logo-bdswiss.svg": 795,
	"./logo-equityflow-black.png": 796,
	"./logo-equityflow-white.png": 797,
	"./logo-facebook.png": 798,
	"./logo-google.png": 799,
	"./logo-google.svg": 800,
	"./logo-lydian-black.png": 801,
	"./logo-lydian-black.svg": 802,
	"./logo-lydian-white.svg": 803,
	"./logo-regalx-white.png": 804,
	"./logo-regalx.png": 805,
	"./logo-skyground-black.svg": 806,
	"./logo-skyground-white.svg": 807,
	"./logo-swissmarkets-white.svg": 808,
	"./logo-swissmarkets.png": 809,
	"./logo-swissmarkets.svg": 810,
	"./logo-tauromarkets-black.png": 811,
	"./logo-tauromarkets-white.png": 812,
	"./logo-tauromarkets-white2.png": 813,
	"./logo-tauromarkets-white2.svg": 814,
	"./logo-valutamarkets.png": 815,
	"./lydian/login-bg.png": 1357,
	"./lydian/logo.svg": 1358,
	"./lydian/lydian-trading-academy-coming_soon.png": 1359,
	"./lydian/lydian-trading-academy.png": 1360,
	"./lydian/lydian-watermark.png": 472,
	"./lydian/trading-academy-logo.svg": 473,
	"./lydian/user-icon.svg": 1361,
	"./maestro.png": 816,
	"./mastercard.png": 817,
	"./mastercard_logo_icon.svg": 818,
	"./mercedesCup-dark.svg": 819,
	"./mercedesCup-light.svg": 820,
	"./mobile/accounts.svg": 1362,
	"./mobile/more.svg": 1363,
	"./mobile/notifications.svg": 1364,
	"./mobile/payments.svg": 1365,
	"./nationalIdBR.png": 821,
	"./nationalIdES.jpg": 822,
	"./nationalIdIT.jpg": 823,
	"./nationalIdZA.png": 824,
	"./no-trades-dark.png": 825,
	"./no-trades-light.png": 826,
	"./no-trading-signals-dark.png": 827,
	"./nok.png": 828,
	"./notifications-empty-dark.png": 829,
	"./notifications-empty-light.png": 830,
	"./onlineBanking.svg": 831,
	"./onlineDeposit.svg": 832,
	"./page-not-found-dark.svg": 450,
	"./page-not-found-light.svg": 451,
	"./payment-failure-dark.png": 833,
	"./payment-failure-light.png": 834,
	"./payment-pending-dark.png": 835,
	"./payment-pending-light.png": 836,
	"./payment-success-dark.png": 837,
	"./payment-success-light.png": 838,
	"./payments-history-empty-dark.png": 839,
	"./payments-history-empty-light.png": 840,
	"./phone_verification.png": 841,
	"./place1-leadership.png": 842,
	"./place2-leadership.png": 843,
	"./place3-leadership.png": 844,
	"./pln.png": 845,
	"./pof-bankStatement.png": 846,
	"./pof-bankStatementPOF.png": 847,
	"./pof-card-back.png": 848,
	"./pof-card.png": 849,
	"./pof-cardStatement.png": 850,
	"./pof-other.png": 851,
	"./pof-proofOfResidence.png": 852,
	"./pof-swiftCopyPaymentAdvice.png": 853,
	"./pof-virtualCard.png": 854,
	"./poi-document.png": 855,
	"./poi-drivingLicense-back.png": 856,
	"./poi-drivingLicense.png": 857,
	"./poi-id-back.png": 858,
	"./poi-id.png": 859,
	"./poi-passport.png": 860,
	"./por-bankStatementPOR.png": 861,
	"./por-document.png": 862,
	"./por-proofOfResidence.png": 863,
	"./por-utilityBill.png": 864,
	"./priority@2x.svg": 865,
	"./referAndEarn.png": 866,
	"./regalxDemo_downloadMT4.png": 867,
	"./regalxReal01_downloadMT4.png": 868,
	"./regalxReal02_downloadMT4.png": 869,
	"./regalxReal03_downloadMT4.png": 870,
	"./regalxReal04_downloadMT4.png": 871,
	"./regalxReal05_downloadMT4.png": 872,
	"./register-referral-light.png": 873,
	"./sek.png": 874,
	"./sign-up.png": 875,
	"./spaceship.png": 876,
	"./spreads@2x.svg": 877,
	"./support@2x.svg": 878,
	"./swissmarketsDemo_downloadMT4.png": 879,
	"./swissmarketsReal02_downloadMT4.png": 880,
	"./swissmarketsReal_downloadMT4.png": 881,
	"./tauroDemo01DownloadMT4.jpg": 882,
	"./tauroReal01DownloadMT4.jpg": 883,
	"./technicalIndicator-ebook.png": 884,
	"./technicalIndicatorItem.svg": 885,
	"./telegram-dark.png": 886,
	"./telegram.png": 887,
	"./trading-alerts-tradingAlerts-dark.png": 888,
	"./trading-alerts-tradingAlerts-light.png": 889,
	"./tradingPsychology-ebook.png": 890,
	"./tradingPsychologyItem.svg": 891,
	"./transfer-external.svg": 892,
	"./transfer-internal.svg": 893,
	"./transfer-spoa.svg": 894,
	"./unlockYourTradingPotentialBanner/education_desktop.webp": 600,
	"./unlockYourTradingPotentialBanner/education_mobile.webp": 601,
	"./upload-bankStatement-error.png": 895,
	"./upload-bankStatement-success.png": 896,
	"./upload-bankStatement.png": 897,
	"./upload-document-dark.png": 898,
	"./upload-document-light.png": 899,
	"./upload-generic-error.png": 900,
	"./upload-generic-success.png": 901,
	"./upload-generic.png": 902,
	"./upload-pof-back-card-error.png": 903,
	"./upload-pof-back-card-success.png": 904,
	"./upload-pof-back-card.png": 905,
	"./upload-pof-front-card-error.png": 906,
	"./upload-pof-front-card-success.png": 907,
	"./upload-pof-front-card.png": 908,
	"./upload-poi-back-drivingLicense-error.png": 909,
	"./upload-poi-back-drivingLicense-success.png": 910,
	"./upload-poi-back-drivingLicense.png": 911,
	"./upload-poi-back-error.png": 912,
	"./upload-poi-back-success.png": 913,
	"./upload-poi-back.png": 914,
	"./upload-poi-front-drivingLicense-error.png": 915,
	"./upload-poi-front-drivingLicense-success.png": 916,
	"./upload-poi-front-drivingLicense.png": 917,
	"./upload-poi-front-error.png": 918,
	"./upload-poi-front-success.png": 919,
	"./upload-poi-front.png": 920,
	"./upload-por-front-error.png": 921,
	"./upload-por-front-proofOfResidence-error.png": 922,
	"./upload-por-front-proofOfResidence-success.png": 923,
	"./upload-por-front-proofOfResidence.png": 924,
	"./upload-por-front-success.png": 925,
	"./upload-por-front-utilityBill-error.png": 926,
	"./upload-por-front-utilityBill-success.png": 927,
	"./upload-por-front-utilityBill.png": 928,
	"./upload-por-front.png": 929,
	"./usd.png": 930,
	"./visa.png": 931,
	"./visa_logo_icon.svg": 932,
	"./vps-enter-credentials.png": 933,
	"./vps-remote-desktop-windows.png": 934,
	"./vps-remote-desktop.png": 935,
	"./waiting-list-skip-dark.png": 936,
	"./waiting-list-skip.png": 937,
	"./windows-brands.svg": 938
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 940;